import type {PilotDemoStatus,Session,Summary} from "./types";
const apiBase=(import.meta.env.VITE_API_BASE_URL??"").replace(/\/$/,"");
const apiUrl=(path:string)=>apiBase?apiBase+path:path;
export class ApiError extends Error{constructor(readonly status:number){super("dashboard request failed");}}
export async function apiRequest<T>(session:Session,path:string,init:RequestInit={},fetcher:typeof fetch=fetch):Promise<T>{
 const headers={authorization:`Bearer ${session.token}`,"x-tenant-id":session.tenantId,accept:"application/json",
  ...(init.body?{"content-type":"application/json"}:{}),...(init.headers as Record<string,string>|undefined)};
 const response=await fetcher(apiUrl(path),{...init,headers});
 if(!response.ok)throw new ApiError(response.status);
 return response.json() as Promise<T>;
}
export function loadSummary(session:Session,fetcher:typeof fetch=fetch):Promise<Summary>{
 return apiRequest(session,"/v1/dashboard/summary",{},fetcher);
}
export function loadPilotDemo(session:Session,fetcher:typeof fetch=fetch):Promise<PilotDemoStatus>{
 return apiRequest(session,"/v1/pilot-demo/latest",{},fetcher);
}
export const getJson=<T>(session:Session,path:string)=>apiRequest<T>(session,path);
export const putJson=<T>(session:Session,path:string,body:unknown)=>apiRequest<T>(session,path,{method:"PUT",body:JSON.stringify(body)});
export const postJson=<T>(session:Session,path:string,body?:unknown)=>apiRequest<T>(session,path,{method:"POST",body:body===undefined?undefined:JSON.stringify(body)});
